import { matchPath } from 'react-router'

import config from 'constants/config'
import { useAppSelector } from 'hooks/reduxHooks'

const tripPlannerPath = '/:regionCode/trip-planner'

export function shouldShowTripPlannerSaveEntryPoints(
  pathname = '',
  enableTripPlanner = config.ENABLE_TRIP_PLANNER,
) {
  return (
    !!enableTripPlanner ||
    !!matchPath(pathname, { path: tripPlannerPath, exact: false })
  )
}

function useShouldShowTripPlannerSaveEntryPoints() {
  const pathname = useAppSelector((state) => state.router.location.pathname)

  return shouldShowTripPlannerSaveEntryPoints(
    pathname,
    config.ENABLE_TRIP_PLANNER,
  )
}

export default useShouldShowTripPlannerSaveEntryPoints
